// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.from[data-v-4726bbb2] {\r\n  line-height: 1;\n}\n.v-expansion-panel-content[data-v-4726bbb2] .v-expansion-panel-content__wrap {\r\n  padding: 0 0.75rem 0.75rem !important;\n}\r\n/*.row {\r\n  border: solid 1px red;\r\n}\r\n.col {\r\n  border: solid 1px orange;\r\n}*/\r\n", ""]);
// Exports
module.exports = exports;
